import is from '@sindresorhus/is';

const VIEWPORT_MARGIN_RATIO = 0.25;
const SCROLL_TARGET_RATIO = 0.33;

export const findScrollableAncestor = (el: Element | null | undefined): Element | null => {
    if (is.nullOrUndefined(el)) return null;
    let node: Element | null = el.parentElement;
    while (!is.null(node)) {
        const style = window.getComputedStyle(node);
        const overflowY = style.overflowY;
        const scrollable = overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay';
        if (scrollable && node.scrollHeight > node.clientHeight + 1) return node;
        node = node.parentElement;
    }
    return null;
};

const getScrollContainerRect = (
    scrollContainer: Element | null,
): { readonly top: number; readonly bottom: number; readonly height: number } => {
    if (is.null(scrollContainer)) {
        return { top: 0, bottom: window.innerHeight, height: window.innerHeight };
    }
    const rect = scrollContainer.getBoundingClientRect();
    return { top: rect.top, bottom: rect.bottom, height: rect.height };
};

export const scrollAnchorIntoViewportIfNeeded = (anchorEl: Element | null | undefined, anchorRect: DOMRect): void => {
    if (is.nullOrUndefined(anchorEl)) return;
    const scrollContainer = findScrollableAncestor(anchorEl);
    const containerRect = getScrollContainerRect(scrollContainer);
    const margin = containerRect.height * VIEWPORT_MARGIN_RATIO;
    if (anchorRect.top >= containerRect.top + margin && anchorRect.bottom <= containerRect.bottom - margin) {
        return;
    }
    const targetY = containerRect.top + containerRect.height * SCROLL_TARGET_RATIO;
    const delta = anchorRect.top - targetY;
    if (is.null(scrollContainer)) {
        window.scrollBy({ top: delta, behavior: 'smooth' });
        return;
    }
    scrollContainer.scrollBy({ top: delta, behavior: 'smooth' });
};

export const scrollOffsetForAncestor = (anchorEl: Element | null | undefined): number => {
    const ancestor = findScrollableAncestor(anchorEl);
    return is.null(ancestor) ? window.scrollY : ancestor.scrollTop;
};
